import { createMiddleware } from '@shared/redux';
import {
    getObjectSelected,
    ObjectSelectedTypes,
    getObjectSelectedIsLoading,
} from '@domain/object-selected';
import { UPDATE_OBJECT_SELECTED } from '@domain/_redux/pareto-ads-app-redux/action/actionTypes';
import {
    disableApplyRule,
    enableApplyRule,
    getCampaignsFiltersInterface,
    ON_CHANGE_VALUE,
    ON_CLICK_APPLY,
    ON_CLICK_CLEAR,
    ON_CLICK_REMOVE_RULE,
} from '../interface';
import {
    applyRules,
    clearRules,
    getCampaignsFilterRules,
    removeRule,
    setCustomFilterRules,
} from './rules.state';
import { getNewRules, hasRule } from './rules.utils';
import {
    createGetFiltersState,
    LOAD_FILTERS_SUCCESS,
    SELECT_CUSTOM_FILTER,
    SELECT_NEW_FILTER,
} from '../filters/filters.state';
import { findCustomFilter } from '../filters/filters.utils';

export const rulesMiddleware = createMiddleware({
    [ON_CLICK_CLEAR]: clearRules,
    [SELECT_NEW_FILTER]: clearRules,
    [SELECT_CUSTOM_FILTER]: (state, action) => {
        const objectSelected = getObjectSelected(state);
        const getFiltersState = createGetFiltersState(objectSelected.type, objectSelected.id);

        const { rules } = findCustomFilter(getFiltersState(state), action.payload);
        return setCustomFilterRules(rules);
    },
    [LOAD_FILTERS_SUCCESS]: (state, action) => {
        if (getObjectSelectedIsLoading(state)) return [];

        const objectSelected = getObjectSelected(state);
        const { type, id } = objectSelected;

        const filters = action.payload?.[type]?.[id];
        if (!filters) return [];

        return setCustomFilterRules(filters?.activeFilter?.rules);
    },
    [ON_CLICK_APPLY]: (state, action) => {
        const rules = getCampaignsFilterRules(state);
        const newRules = getNewRules(action.payload, rules);

        return applyRules(newRules);
    },
    [ON_CLICK_REMOVE_RULE]: (_, action) => removeRule(action.payload),
    [UPDATE_OBJECT_SELECTED]: (state, action) => {
        const type = action.objectSelected.data.type === ObjectSelectedTypes.client
            ? ObjectSelectedTypes.client
            : ObjectSelectedTypes.account;

        const getFiltersState = createGetFiltersState(type, action.objectSelected.data.id);
        const { activeFilter } = getFiltersState(state);

        return setCustomFilterRules(activeFilter.rules);
    },
    [ON_CHANGE_VALUE]: (state) => {
        const rules = getCampaignsFilterRules(state);
        const { field, operator, value } = getCampaignsFiltersInterface(state);

        const isDuplicatedRule = hasRule(
            rules,
            { field: field.value, operator: operator?.value, value: value?.value },
        );

        if (isDuplicatedRule) {
            return disableApplyRule();
        }
        return enableApplyRule();
    },
});
